import React, { useState } from 'react';
import Modal from '@omilia/modal';
import Dropzone from '@omilia/dropzone';
import Button, { ButtonGroup } from '@omilia/button';
import styled from 'styled-components';

export type Props = {
  isLoading: boolean;
  onUpdate: ({ nlu_file }: { nlu_file: File }) => void;
  onClose: () => void;
  onCancelUpdating: () => void;
};

const SContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;

  & > ul {
    margin: 14px 0 0 0;
  }
`;

const SButtonGroup = styled(ButtonGroup)`
  align-self: flex-end;
  margin-top: 20px;
`;

const UpdateXpackModal = ({
  isLoading,
  onUpdate,
  onClose,
  onCancelUpdating,
}: Props) => {
  const [files, setFiles] = useState<File[]>([]);

  const handleUploadFiles = async () => {
    await onUpdate({
      nlu_file: files[0],
    });

    onClose();
  };

  const handleClose = () => {
    onCancelUpdating();
    onClose();
  };

  return (
    <Modal
      open
      glyph="xpacks"
      subtitle="To update xPack add file and click update button"
      title="Update xPack"
      onClose={onClose}
    >
      <SContainer>
        <Dropzone
          accept=".nlu"
          description="Drop .nlu here to import"
          isLoading={isLoading}
          multiple={false}
          onChange={setFiles}
        />
        <SButtonGroup>
          <Button
            color="secondary"
            data-test="cancel-update-button"
            variant="text"
            onClick={handleClose}
          >
            Cancel
          </Button>
          <Button
            color="primary"
            data-test="update-button"
            disabled={files.length < 1}
            loading={isLoading}
            variant="contained"
            onClick={handleUploadFiles}
          >
            Update
          </Button>
        </SButtonGroup>
      </SContainer>
    </Modal>
  );
};

export default UpdateXpackModal;
